import { TransactionAmount } from '../../../../codegen/transactions';
import { SidebarRow } from '../../../../components/sidebar/SidebarRow';
import { TranslationsKeys } from '../../../../i18n/i18n';
import { MonetaryValue } from '../../../../components/MonetaryValue';

type AmountRowProps = {
  amount: TransactionAmount;
  netLabel: TranslationsKeys;
  grossLabel: TranslationsKeys;
  highlightLabel?: boolean;
  weaklyDisplayAmounts?: boolean;
};

export const AmountRows = ({
  amount,
  netLabel,
  grossLabel,
  highlightLabel,
  weaklyDisplayAmounts,
}: AmountRowProps) => {
  return (
    <>
      <SidebarRow
        label={grossLabel}
        highlightLabel={highlightLabel}
        fadeValue={weaklyDisplayAmounts}
      >
        <MonetaryValue
          amount={parseFloat(amount.amountGross)}
          currency={amount.currency}
          strikethrough={weaklyDisplayAmounts}
        />
      </SidebarRow>
      <SidebarRow
        label={netLabel}
        highlightLabel={highlightLabel}
        fadeValue={weaklyDisplayAmounts}
      >
        <MonetaryValue
          amount={parseFloat(amount.amountNet)}
          currency={amount.currency}
          strikethrough={weaklyDisplayAmounts}
        />
      </SidebarRow>
    </>
  );
};
